import { StorageKeys } from "./AppMode"

const copyPictureGeom = (picture) => {
  sessionStorage.setItem(StorageKeys().CLIPBOARD_GEOM_SRC_KEY, picture.src)
  sessionStorage.setItem(StorageKeys().CLIPBOARD_GEOM_ID_KEY, picture.id)
  let name = picture.src ?? "unknown"
  if (name.includes("/")) {
    name = name.split("/")
    name = name[name.length - 1]
  }
  sessionStorage.setItem(StorageKeys().CLIPBOARD_GEOM_NAME_KEY, name)
  window.dispatchEvent(
    new StorageEvent("storage", {
      key: StorageKeys().CLIPBOARD_GEOM_SRC_KEY,
      newValue: picture.src,
    })
  )
  window.dispatchEvent(
    new StorageEvent("storage", {
      key: StorageKeys().CLIPBOARD_GEOM_ID_KEY,
      newValue: picture.id,
    })
  )
  window.dispatchEvent(
    new StorageEvent("storage", {
      key: StorageKeys().CLIPBOARD_GEOM_NAME_KEY,
      newValue: name,
    })
  )
}

const getPictureGeom = () => {
  const source_id = sessionStorage.getItem(StorageKeys().CLIPBOARD_GEOM_ID_KEY)
  const source_name = sessionStorage.getItem(
    StorageKeys().CLIPBOARD_GEOM_NAME_KEY
  )
  const source_imgsrc = sessionStorage.getItem(
    StorageKeys().CLIPBOARD_GEOM_SRC_KEY
  )
  return { id: source_id, name: source_name, gc: source_imgsrc }
}

/** @returns {boolean}*/
const hasPictureGeom = () =>
  Boolean(sessionStorage.getItem(StorageKeys().CLIPBOARD_GEOM_ID_KEY))

/**
 * Parse a link stored by "Copy Link" (format: `<src>#<fileId>`)
 * @returns {{id: string, src: string, name: string} | null}
 */
const parseFileLink = (link) => {
  if (typeof link !== "string" || !link.includes("#")) return null
  const sep = link.lastIndexOf("#")
  const id = link.slice(sep + 1)
  if (!id) return null
  const src = link.slice(0, sep)
  const name = decodeURIComponent(src.slice(src.lastIndexOf("/") + 1))
  return { id, src, name }
}

const clearClipboard = () =>
  Object.entries(StorageKeys()).forEach((elt) => {
    if (elt[0].startsWith("CLIP")) {
      sessionStorage.removeItem(elt[1])
    }
  })

export {
  getPictureGeom,
  copyPictureGeom,
  hasPictureGeom,
  clearClipboard,
  parseFileLink,
}
